var _defs, _style, _circle, _circle2, _path, _text, _text2, _use, _use2, _use3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Star soft design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,100a85,85 0 1,0 170,0a85,85 0 1,0 -170,0",
    id: "coffeecircle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,37c34.8,0,63,28.2,63,63s-28.2,63-63,63s-63-28.2-63-63S65.2,37,100,37z",
    id: "starbuckscircle",
    transform: "rotate(-85 100 100)"
  }), /*#__PURE__*/React.createElement("symbol", null, /*#__PURE__*/React.createElement("path", {
    id: "star",
    fill: "gold",
    d: "M29.3,115.4c2.4,0,4.8,0.1,7.3,0l-5.6,4.7c0.5,2,1,4.2,1.7,6.8l-5.5-3.8c-2.3,1.1-3.7,2.4-6.1,3.6 l1.9-6.6c-1.8-1.5-3.9-2.9-5.6-4.4c2.5-0.1,4.7,0,7.1,0c1.1-2.1,1.6-4.5,2.6-6.6L29.3,115.4"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\ntext { \r\n    font-family: Santana-Black, sans-serif; \r\n    fill: #fff;\r\n    text-transform: uppercase;\r\n    font-size: 32px;\r\n}\r\n.coffee { letter-spacing: 6px; }\r\n    ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "skyblue",
    id: "background"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFF",
    cx: 100,
    cy: 100,
    r: 93.8,
    strokeWidth: 3,
    id: "rim"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3,115.4c2.4,0,4.8,0.1,7.3,0l-5.6,4.7c0.5,2,1,4.2,1.7,6.8l-5.5-3.8c-2.3,1.1-3.7,2.4-6.1,3.6 l1.9-6.6c-1.8-1.5-3.9-2.9-5.6-4.4c2.5-0.1,4.7,0,7.1,0c1.1-2.1,1.6-4.5,2.6-6.6L29.3,115.4",
    fill: "gold"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#starbuckscircle",
    fill: "blue"
  }, "Star soft"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    dx: 55,
    textLength: 160,
    className: "coffee"
  }, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#coffeecircle",
    fill: "red"
  }, "Design"))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(72)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(146)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: " matrix(0.866, -0.5, 0.25, 0.433, 80, 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,70 A 65,70 0 0,0 65,0 5,5 0 0,1 75,0 75,70 0 0,1 0,70Z",
    fill: "gold"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 0 0",
    to: "0 0 0",
    dur: "2s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlogo);
export default __webpack_public_path__ + "static/media/starlogo.9df7b8a3fb712386fc2d87cfa3cd167f.svg";
export { ForwardRef as ReactComponent };